import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["value", "pickerConfig", "singlePanel", "update", "state", "selectedDate", "className", "defaultPickerValue", "open"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from '@jd/jmtd-tools/es/classnames';
import { addDate, diffInMonth } from '@jd/jmtd-tools/es/date';
import React from 'react';
import Calendar from '../Calendar';
import DatePickerDropdownList from '../DatePickerDropdownList';
import DatePickerHeader from '../DatePickerHeader';
var PANEL_DATE = Symbol('panelDate');
var LAST_VALUE = Symbol('panelDate'); // 双日历面板

export default function DoubleCalendar(_ref) {
  var value = _ref.value,
      pickerConfig = _ref.pickerConfig,
      _ref$singlePanel = _ref.singlePanel,
      singlePanel = _ref$singlePanel === void 0 ? false : _ref$singlePanel,
      update = _ref.update,
      state = _ref.state,
      selectedDate = _ref.selectedDate,
      className = _ref.className,
      defaultPickerValue = _ref.defaultPickerValue,
      open = _ref.open,
      calendarProps = _objectWithoutProperties(_ref, _excluded);

  // 值更新时清空状态
  try {
    if (open && JSON.stringify(state[LAST_VALUE]) !== JSON.stringify(value)) {
      delete state[PANEL_DATE];
      state[LAST_VALUE] = value;
    } // eslint-disable-next-line no-empty

  } catch (_unused) {}

  var panelDates = state[PANEL_DATE]; // 面板日期，比如2020年03月

  if (!panelDates) {
    var lastSelectedDate = selectedDate && selectedDate[1] || new Date();
    var initPanelDate = [addDate(lastSelectedDate, -1, 'month'), lastSelectedDate];

    if (defaultPickerValue) {
      initPanelDate = defaultPickerValue.map(function (v) {
        return new Date(v[0], v[1] - 1);
      });
    }

    panelDates = state[PANEL_DATE] = initPanelDate;
  }

  var canNotChangeMonth = diffInMonth.apply(void 0, _toConsumableArray(panelDates)) === 1;
  var canNotChangeYear = diffInMonth.apply(void 0, _toConsumableArray(panelDates)) <= 12;

  function Panel(index) {
    var _pickerConfig$index;

    var panelDate = panelDates[index];
    var disableBtn = {};

    if (index === 0) {
      disableBtn.nextMonth = canNotChangeMonth;
      disableBtn.nextYear = canNotChangeYear;
    } else {
      disableBtn.prevMonth = canNotChangeMonth;
      disableBtn.prevYear = canNotChangeYear;
    }

    return /*#__PURE__*/React.createElement(DatePickerDropdownList, {
      className: classNames('jmtd-date-picker-double-calendar', className)
    }, /*#__PURE__*/React.createElement(DatePickerHeader, {
      date: panelDate,
      onSwitch: function onSwitch(nextDate) {
        // 切换面板日期
        panelDates[index] = nextDate;
        update();
      },
      disableBtn: _objectSpread(_objectSpread({}, disableBtn), pickerConfig === null || pickerConfig === void 0 ? void 0 : (_pickerConfig$index = pickerConfig[index]) === null || _pickerConfig$index === void 0 ? void 0 : _pickerConfig$index.disableBtn)
    }), /*#__PURE__*/React.createElement(Calendar, _extends({
      date: panelDate
    }, calendarProps)));
  }

  return {
    dropdown: /*#__PURE__*/React.createElement(React.Fragment, null, !singlePanel && Panel(0), Panel(1))
  };
}